import { Icon, IconComponent } from '@graftcode/design-system'

import styles from '../../FiltersMobileSheet.module.scss'

type FilterSheetMenuItemProps = {
  label: string
  isSelected: boolean
  onSelect: () => void
  testId?: string
}

export function FilterSheetMenuItem({ label, isSelected, onSelect, testId }: FilterSheetMenuItemProps) {
  return (
    <button
      type="button"
      data-testid={testId ?? undefined}
      className={`${styles.menuItem} ${isSelected ? styles.menuItemSelected : ''}`}
      onClick={onSelect}
    >
      <span className={styles.menuItemLabel}>{label}</span>
      {isSelected ? <IconComponent icon={Icon.CheckmarkRegular} className={styles.menuItemCheck} /> : null}
    </button>
  )
}
